import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../../services/component.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'app-gallery-image',
	templateUrl: './gallery-image.component.html',
	styleUrls: ['./gallery-image.component.scss']
})
export class GalleryImageComponent implements OnInit, OnDestroy {
	@ViewChild('imageForm', { static: true }) imageForm: NgForm;
	@Input() galleryImage: any;
	@Input() componentData: any;
	@Input() urlGlobalRegExp: any;
	@Input() index: any;
	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onUploadSuccess = new EventEmitter<any>();
	@Output() invalidURLMarker = new EventEmitter<any>();
	@Input() allowedDimensions: string;
	imageFormSubscription: Subscription;
	linkFocus = Boolean(false);

	constructor(private cs: ComponentService) {}

	ngOnInit() {
		if (this.index === 0) {
			this.allowedDimensions = null;
		}

		this.imageFormSubscription = this.imageForm.valueChanges
			.pipe(
				tap(() => {
					this.cs.updateDisabledSave(
						this.componentData.config.images[this.index].src === '' || (this.imageForm.dirty && this.imageForm.invalid)
					);

					if (this.imageForm.controls.link.invalid) {
						this.invalidURLMarker.emit({ index: this.index, invalid: true });
					} else {
						this.invalidURLMarker.emit({ index: this.index, invalid: false });
					}
				})
			)
			.subscribe((form) => {
				this.componentData.config.images[this.index].url = form.link;
			});
	}

	ngOnDestroy(): void {
		this.imageFormSubscription.unsubscribe();
	}

	externalImageAddition(): void {
		this.cs.updateDisabledSave(false);
	}

	onImageUploadSuccess(event) {
		this.onUploadSuccess.emit({
			url: event && event.url,
			index: this.index
		});
	}
}
